/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Already_Have_AccountInputs */



/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Login_Already_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_already_have_account = /** @type {((inputs?: Login_Already_Have_AccountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Already_Have_AccountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez déjà un compte ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben bereits ein Konto?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Hai già un account?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("У вас уже есть аккаунт?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Ya tienes una cuenta?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已有账号？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すでにアカウントをお持ちですか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आपके पास पहले से एक खाता मौजूद है?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Já tem uma conta?")
	return /** @type {LocalizedString} */ ("Already have an account?")
});